var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"5"}},[_c('movie-detail-card',{attrs:{"movie":_vm.currentMovie || _vm.movieDetails,"cast":_vm.movieCast,"details":_vm.movieDetails}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }